import classNames from "classnames";
import React from "react";
import { WidgetFormTextInput } from "@fidget/common/components/chat/widgetFormTextInput/widgetFormTextInput";
import styles from "./textInput.css";

interface Props extends React.HTMLProps<HTMLTextAreaElement> {
  label?: string;
  labelClass?: string;
  containerClass?: string;
}

export const TextInput = (props: Props) => {
  const { label, labelClass, containerClass, ...inputProps } = props;
  return (
    <div className={containerClass}>
      {label && (
        <label htmlFor="textInput" className={classNames(styles.label, labelClass)}>
          {label}
        </label>
      )}
      <WidgetFormTextInput {...inputProps} id="textInput" />
    </div>
  );
};
